import { render, staticRenderFns } from "./ReadingReportDetail.vue?vue&type=template&id=34b92606&scoped=true&"
import script from "./ReadingReportDetail.vue?vue&type=script&lang=js&"
export * from "./ReadingReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReadingReportDetail.vue?vue&type=style&index=0&id=34b92606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b92606",
  null
  
)

export default component.exports